import React, { FC, useMemo } from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import RouteErrorBoundaryWrapper from './RouteErrorBoundary.styled';

const RouteErrorBoundaryComponent: FC = (): JSX.Element => {
  const error = useRouteError();

  const description = useMemo(() => {
    let text = 'Error no controlado';
    if (isRouteErrorResponse(error)) {
      switch (error?.status) {
        case 404:
          text = "This page doesn't exist!";
          break;
        case 401:
          text = "You aren't authorized to see this";
          break;
        case 503:
          text = 'Looks like our API is down';
          break;
        case 418:
          text = '🫖';
          break;

        default:
          text = 'Something went wrong';
          break;
      }
    }

    return text;
  }, [error]);

  return (
    <RouteErrorBoundaryWrapper data-testid="RouteErrorBoundaryComponent" className="RouteErrorBoundaryComponent">
      {description}
    </RouteErrorBoundaryWrapper>
  );
};

export default RouteErrorBoundaryComponent;
